import PropTypes from "prop-types"
import MonthYearPicker from "../../MonthYearPicker"
import StatePicker from "../../StatePicker"
import FranchiseePicker from "../../FranchiseePicker"
import FilterFieldsLeftButtonRight from "../../Filter/FilterFieldsLeftButtonRight"

const ComparativoReceitaRecebidoFilter = ({ filters, setFilters, clickFilter, clearFilter, isClub = false }) => (
  <>
    <h2>Comparativo Receita x Recebido{isClub ? ' Franquias' : ''}</h2>
    <FilterFieldsLeftButtonRight clickFilter={clickFilter} clearFilter={clearFilter}>
      <MonthYearPicker
        value={filters}
        onChange={setFilters}
      />

      {isClub && (<>
        <StatePicker
          value={filters}
          onChange={setFilters}
        />
        <FranchiseePicker
          value={filters}
          onChange={setFilters}
        />
      </>)}
    </FilterFieldsLeftButtonRight>
  </>
)

ComparativoReceitaRecebidoFilter.propTypes = {
  filters: PropTypes.shape({
    year: PropTypes.number.isRequired,
    month: PropTypes.number.isRequired
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  clickFilter: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  isClub: PropTypes.bool
}

ComparativoReceitaRecebidoFilter.defaultProps = {
  isClub: false
}

export default ComparativoReceitaRecebidoFilter